import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useAllNominals } from "services/nominalsService";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { clearNominalFields } from "actions/postings.action";

export const DropDownCell = (props) => {
  const [data, setData] = React.useState([]);
  const { data: allNominals } = useAllNominals();
  const localizedData = allNominals || [];
  const clearFields = useSelector((state) => state.postingsdocs.clearFields);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    if (!clearFields) {
      dispatch(clearNominalFields(true));
    }
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.value,
      });
    }
  };

  const filterData = (filter) => {
    const data = localizedData.slice();
    return filterBy(data, filter);
  };

  const filterChange = (event) => {
    setData(filterData(event.filter));
  };

  const { dataItem } = props;
  const field = props.field || "";
  const dataValue = dataItem[field] === null ? "" : dataItem[field];

  return (
    <td>
      <ComboBox
        style={{
          height: "35px",
        }}
        className="d-flex justify-content-start align-items-center me-auto"
        onChange={handleChange}
        value={
          clearFields ? localizedData.find((c) => c.value === dataValue) : null
        }
        data={data.length > 0 ? data : localizedData}
        textField="display"
        dataItemKey="nominalRef"
        filterable={true}
        onFilterChange={filterChange}
        placeholder="Select Nominal Ref"
        allowCustom={false}
      />
    </td>
  );
};
